var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-radio-group",class:{
  'fm-radio-group-vertical': _vm.vertical === undefined || _vm.vertical === true
}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }